import { useState, useEffect, useMemo, useCallback } from "react";
import { useData } from "../DataContext/DataContextt";
import { buildOptions } from "../../helpers/EntityHelper";

export const usePreparationData = ({ sources = [] }) => {
  const {
    language,
    groups,
    classes,
    featureGroups,
    units,
    values,
    features,
    reload,
  } = useData();

  useEffect(() => {
    if (!sources?.length) return;

    reload(sources);
  }, [language]);

  const groupOptions = useMemo(
    () =>
      buildOptions(groups?.results, "groupCode", [
        "groupDisplayName",
        "groupName",
      ]),
    [groups?.results],
  );

  const classOptions = useMemo(
    () =>
      buildOptions(
        classes?.results,
        "id",
        ["classDisplayName", "className"],
        ["className", "classDisplayName", "classDescription", "classGroupCode"],
      ),
    [classes?.results],
  );

  const featureGroupOptions = useMemo(
    () =>
      buildOptions(featureGroups?.results, "id", [
        "featureGroupDisplayName",
        "featureGroupName",
      ]),
    [featureGroups?.results],
  );

  const unitOptions = useMemo(
    () => buildOptions(units?.results, "id", ["unitDisplayName", "unitName"]),
    [units?.results],
  );

  const valueOptions = useMemo(
    () =>
      buildOptions(
        values?.results,
        "id",
        ["valueDisplayName", "valueName"],
        [
          "valueCode",
          "valueName",
          "valueDisplayName",
          "valueTooltip",
          "valueCodeOld",
          "valueCodeAlternative",
          "valueImage",
        ],
      ),
    [values?.results],
  );

  const featureOptions = useMemo(
    () =>
      buildOptions(
        features?.results,
        "id",
        ["featureDisplayName", "featureName"],
        [
          "featureType",
          "featureDisplayName",
          "featureName",
          "defaultValues",
          "defaultUnit",
        ],
      ),
    [features?.results],
  );

  return {
    classOptions,
    groupOptions,
    featureGroupOptions,
    unitOptions,
    valueOptions,
    featureOptions,
  };
};
